import React from "react";
import { Grid, Box, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as AddOrderToList } from "Assets/Icons/AddOrderToList.svg";
import { ReactComponent as CreateNewRxOrder } from "Assets/Icons/CreateNewRxOrder.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Button from "Components/Common/Button/Button";
import clsx from "clsx";
import useViewport from "Hooks/useViewport";

const useStyle = makeStyles((theme) => ({
  rsOrderPadGrid: {
    "&>div": {
      marginBottom: "15px",
      // paddingLeft:"12px !important",
      "&>h3": {
        fontSize: "20px !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        marginTop: "10px",
      },
    },
  },
  rsOrderPadBtn: {
    // padding: "10px 0px",
    height: "59px",
    // width: "50%",
    width: "385px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginBottom: "25px !important",
    [theme.breakpoints.down("1315")]: {
      width: "100%",
    },
    [theme.breakpoints.down("768")]: {
      width: "100%",
    },
    "&>h3": {
      fontSize: "13px !important",
      marginBottom: "30px",
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsPatientCreateBtn: {
    // marginTop: "20px !important",
    // margin: "10px !important",
    whiteSpace: "nowrap",
    background: "White !important",
    color: "#747474 !important",
    // marginTop: "20px !important",
    margin: "10px !important",
    whiteSpace: "nowrap",
    // boxShadow: "0px 7px #309562 !important",
    border: "1px solid #747474 !important",
    fontSize: "14px !important",
    padding: "8px 20px !important",
    fontWeight: "600 !important",
    // height: "45px !important",
    height: "38px !important",
    borderRadius: "5px !important",
    minWidth: "120px !important",
    // textTransform: "uppercase !important",
    [theme.breakpoints.down("769")]: {
      fontSize: "11px !important",
    },
    "&>span": {
      "&>svg": {
        width: "25px !important",
        height: "25px !important",
        fill: "#747474 !important",
        [theme.breakpoints.down("769")]: {
          width: "20px !important",
        },
      },
    },
  },
  rsActiveTab: {
    background: "#7BC044 !important",
    color: "white !important",
    // marginTop: "20px !important",
    margin: "10px !important",
    whiteSpace: "nowrap",
    fontSize: "14px !important",
    padding: "8px 20px !important",
    fontWeight: "600 !important",
    height: "38px !important",
    borderRadius: "5px !important",
    minWidth: "120px !important",
    // textTransform: "uppercase !important",
    [theme.breakpoints.down("769")]: {
      fontSize: "11px !important",
    },
    "&>span": {
      "&>svg": {
        width: "25px !important",
        height: "25px !important",
        fill: "white !important",
        [theme.breakpoints.down("769")]: {
          width: "20px !important",
        },
      },
    },
  },
}));

const OptionForAddToOrderAndOrderNew = (props) => {
  const classes = useStyle();
  const {
    setSelectedPatientInfo,
    setOrderType,
    setShowOrderList,
    setShowCreateNewRx,
    setOrderPadData,
    formState,
    setShowWholeForm,
    setListOpen,
    showOrderList,
    showCreateNewRx,
  } = props;

  const { width } = useViewport();

  return (
    <>
      <Grid
        container
        columnSpacing={2.5}
        rowSpacing={3}
        className={classes.rsOrderPadGrid}
      >
        <Grid item xs={12} sm={12} md={ width < 1050 ? 7.5 : 6} lg={5} xl={6}>
          <Paper elevation={0} className={classes.rsOrderPadBtn}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box display={"flex"} justifyContent={"space-evenly"}>
                <Button
                  children="Add Order To List"
                  variant="contained"
                  color="primary"
                  className={clsx(
                    showOrderList === true
                      ? classes.rsActiveTab
                      : classes.rsPatientCreateBtn
                  )}
                  startIcon={
                    <PrimaryIcon
                      icon={AddOrderToList}
                      color="white"
                      width="20px"
                      height="20px"
                    />
                  }
                  onClick={() => {
                    setOrderType("addOrder");
                    setShowOrderList(true);
                    setShowCreateNewRx(false);
                    setOrderPadData(formState);
                    setShowWholeForm(false);
                    setSelectedPatientInfo({});
                    setListOpen(false);
                  }}
                />
                <Button
                  className={clsx(
                    showCreateNewRx === true
                      ? classes.rsActiveTab
                      : classes.rsPatientCreateBtn
                  )}
                  children="Order New RX"
                  variant="contained"
                  color="primary"
                  startIcon={
                    <PrimaryIcon
                      icon={CreateNewRxOrder}
                      color="white"
                      width="20px"
                      height="20px"
                    />
                  }
                  onClick={() => {
                    setOrderType("createNewOrder");
                    setShowCreateNewRx(true);
                    setShowOrderList(false);
                    setOrderPadData(formState);
                    setShowWholeForm(false);
                    setSelectedPatientInfo({});
                    setListOpen(false);
                  }}
                />
              </Box>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default OptionForAddToOrderAndOrderNew;
